
import { TaskHandler } from '../TaskHandler';

import { Component, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { CommunicationEditionComponent } from '../../dossiers/communications/communication.edition.component';
import { CommunicationDTO } from '../../api/plyca-dtos-v2';
import { Configuration } from '../../conf/app.constants';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { documentViewerComponent } from '../../documents/documentViewer/documentViewer.component';
import { MasterDataDTO } from '../../api/plyca-dtos';


@Component({
  selector: 'ChangePhaseTask',
  templateUrl: 'changePhaseTask.template.html',
  providers: [DialogService]
})
export class ChangePhaseTaskComponent extends TaskHandler implements AfterViewInit, OnDestroy {


  constructor(
    private headerActionsService: HeaderActionsService
  ) {
    super();
  }

  ngAfterViewInit(): void {

    let work = this.task.work;
    if (!work.selectedPhase) {
      work.selectedPhase = work.possiblePhases[0].identifier;
    }


    this.headerActionsService.clearActions();
    this.subscribe(this.headerActionsService.addAction(
      'General.accept',
      'fas fa-lg fa-check',
      'btn-primary',
      true
    ),
      success => {
        this.processTask();
      });
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService.addAction(
      'General.cancel',
      'fas fa-times',
      'btn-outline-secondary',
      true
    ), success => {
      this.salir();
    });
    this.waitService.cancelWaiting();
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearWindowActions(this.modalWindowHash);
    super.ngOnDestroy();
  }

}
